import { ListItemButton, ListItemButtonProps } from '@mui/material'
import { createLink } from '@tanstack/react-router'

const InnerListItemButtonLink: React.FC<
    React.PropsWithChildren<
        { ref: React.RefObject<HTMLAnchorElement> } & ListItemButtonProps
    >
> = ({ children, ref, ...props }) => (
    <ListItemButton component={'a'} ref={ref} {...props}>
        {children}
    </ListItemButton>
)

export const ListItemButtonLink = createLink(InnerListItemButtonLink)
